import useUsuario from "~fetchs/useUsuario";
import React, { useEffect, useRef, useState } from "react";
import { ArrowIcon, ModalClosed } from "~misc/icons";
import "./index.scss";
import { Form, Formik } from "formik";
import useModalUpdate from "./hooks/useModalUpdate";
import ensacados from "../../assets/images/ensacados.png";
import useModalSimulators from "./hooks/useModalSimulators";
import Select from "~components/Form/components/Select";
import useClientes from "~/fetchs/useClientes";
import { useNavigate, Link } from "react-router-dom";
import useCliente from "~fetchs/useCliente";

const ModalSimulators = ({ isOpen, onClose, clienteId }) => {
  const { usuario } = useUsuario();
  const navigate = useNavigate();
  const { optionSelect } = useModalUpdate();
  const modalClasses = isOpen ? "fixed inset-0 bg-black bg-opacity-0 z-[99999]" : "hidden";
  const overlayClasses = isOpen ? "fixed inset-0 bg-black opacity-50 z-40" : "hidden";
  const { filteredCustomers, initial, validation } = useModalSimulators();
  const formikRef = useRef();
  const [selectedClienteId, setSelectedClienteId] = useState(clienteId || null);
  const [selectedCliente, setSelectedCliente] = useState(null);

  const viteMode = import.meta.env.VITE_MODE;
  const simuladoresLink = viteMode === "dev" ? "qa" : viteMode === "prod" ? "" : viteMode;
  const linkSimuladorImo = `https://comercial${simuladoresLink ? `-${simuladoresLink}` : ""}.vcimentos.com/#/imo`;

  const clienteSelecionado = Number(selectedCliente?.id) === Number(selectedClienteId)
    ? selectedCliente
    : null;
  const dadosDisponiveis = Boolean(clienteSelecionado?.trilha?.nome && clienteSelecionado?.codigo);
  const { cliente: clienteConsultado } = useCliente(selectedClienteId, !dadosDisponiveis);
  const cliente = dadosDisponiveis ? clienteSelecionado : clienteConsultado;
  const acessoSimuladorConcreto = 
    Number(cliente?.id) === Number(selectedClienteId) && 
    ["IMO", "INFRA"].includes(cliente?.trilha?.nome?.toUpperCase()) && 
    usuario?.slugAcessos?.includes('acesso-ao-menu-de-funil-de-obras');
    
  const { clienteSelect, onChangeCliente, handleSearch, options, clientes } = useClientes({
    formikRef,
    type: "optionsSimulacao",
    campo: "simulador",
    enabledRequest: false,
  });

  useEffect(() => {
    if (clienteId) {
      setSelectedClienteId(clienteId);
      formikRef.current.setFieldValue("simulador", clienteId);
    }
  }, [clienteId]);

  return (
    <Formik
      innerRef={formikRef}
      initialValues={initial}
      validationSchema={validation}
      onSubmit={(values) => {
        if (values.simulador > 0) navigate(`/simuladores/${values.simulador}/simulacao-nova`);
      }}
    >
      {({ errors, touched, setFieldValue, setFieldTouched, values }) => {

        const handleConcreto = () => {
          if (!values.simulador || !acessoSimuladorConcreto) return;
          window.open(`${linkSimuladorImo}/${cliente.codigo}`, "_blank");
        };
      return (
        <Form className={modalClasses}>
          <div className="fixed inset-0 flex items-center justify-center z-50">
            <div className="bg-white min-w-[680px] px-14 py-14 rounded-[20px] shadow-lg z-50  relative">
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={onClose}
                  className="text-gray-500 p-4 rounded-tr-[20px] hover:text-gray-700 bg-quinaria absolute top-0 right-0"
                >
                  <ModalClosed />
                </button>
              </div>
              {!clienteId && (
                <div>
                  <label className="field__label text-[1.2rem] font-bold block mb-2">Selecione o Cliente </label>
                  <Select
                    name="simulador"
                    label=""
                    placeholder="Digite para Buscar o Cliente"
                    options={options}
                    noOptionsMessage="Cliente não encontrado"
                    onChange={(e) => {
                      setSelectedCliente(clientes.find((item) => Number(item.id) === Number(e?.value)) ?? null);
                      onChangeCliente(e ?? { value: null });
                      setSelectedClienteId(e?.value ?? null);
                    }}
                    onInputChange={handleSearch}
                    errors={errors.simulador}
                    touched={touched.simulador}
                    setFieldValue={setFieldValue}
                    {...clienteSelect}
                  />
                </div>
              )}
              {selectedClienteId && (
                <div>
                  <label className="field__label text-[1.2rem] font-bold block mt-6 mb-2">Selecione o Simulador </label>
                    <div className="flex flex-col gap-y-4">
                      <div className="flex items-center gap-x-4 justify-between">
                      <div className="flex items-center gap-x-4">
                        <div className="bg-primaria rounded-full max-w-[100px] flex justify-center p-6">
                          <img src={ensacados} alt="" />
                        </div>
                        <h3 className="font-bold text-[1.2rem]">ENSACADOS</h3>
                      </div>
                      <button
                        type="submit"
                        className="rotate-[180deg]"
                      >
                        <ArrowIcon />
                      </button>
                    </div>
                    {acessoSimuladorConcreto && (
                      <div className="flex items-center gap-x-4 justify-between">
                        <div className="flex items-center gap-x-4">
                          <div className="bg-primaria rounded-full max-w-[100px] flex justify-center p-6">
                            <img src={ensacados} alt="" />
                          </div>
                          <h3 className="font-bold text-[1.2rem]">CONCRETO</h3>
                        </div>
                        <button
                          onClick={handleConcreto}
                          type="button"
                          className="rotate-[180deg]"
                        >
                          <ArrowIcon />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
            <div className={overlayClasses} onClick={onClose}></div>
          </div>
        </Form>
      )}}
    </Formik>
  );
};

export default ModalSimulators;
